module.exports = __webpack_public_path__ + "img/banner-society.8f3db786.png";